import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { useIsAdmin } from "../../../auth/authUtils";

import ErrorMessage from "../../../components/alert/ErrorMessage";
import UploadMediaDialog from "./UploadMediaDialog";

const UploadMedia = () => {
  const match = useRouteMatch("/creator/upload");
  const history = useHistory();
  const isAdmin = useIsAdmin();

  const [open, setOpen] = useState(false);
  const handleCancel = () => history.goBack();

  useEffect(() => {
    if (match) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [match]);

  return isAdmin ? (
    <ErrorMessage
      display="flex"
      justifyContent="center"
      alignItems="center"
      bgcolor="white"
      height="calc(100vh - 200px)"
      borderRadius={20}
      error={{
        message: "Sorry! Must be logged into an organization to upload media",
      }}
    />
  ) : (
    <UploadMediaDialog visible={open} onCancel={handleCancel} />
  );
};

export default UploadMedia;
